<template>
  <b-container>
    <div class="exam__list">

      <div class="exam__list__parent">
        <div></div>
        <h3 class="exam__list__title">{{ examCategory.name }}</h3>
        <div></div>
      </div>

      <b-row>
        <b-col v-for="exam in examCategory.exams" :key="exam.exam_id" md="3" sm="4" xs="12">
          <ExamBox :exam="exam" />
        </b-col>
      </b-row>
    </div>

    <template v-if="pagination.totalPages > 1">
      <div class="pager-wrapper">
        <ul class="pager">
          <template v-if="pagination.currentPage - 3 > 0">
            <li class="pager__item"><b-link class="pager__link" :to="{ name: 'exam-category', params: { id: id, slug: slug }, query: { page: 1 } }">&laquo;</b-link></li>
          </template>
          <template v-if="pagination.currentPage - 3 > 0">
            <li class="pager__item"><span class="pager__link pager__link--disable">...</span></li>
          </template>
          <template v-if="pagination.currentPage - 2 > 0">
            <li class="pager__item"><b-link class="pager__link" :to="{ name: 'exam-category', params: { id: id, slug: slug }, query: { page: pagination.currentPage - 2 } }">{{ pagination.currentPage - 2 }}</b-link></li>
          </template>
          <template v-if="pagination.currentPage - 1 > 0">
            <li class="pager__item"><b-link class="pager__link" :to="{ name: 'exam-category', params: { id: id, slug: slug }, query: { page: pagination.currentPage - 1 } }">{{ pagination.currentPage - 1 }}</b-link></li>
          </template>
          <li class="pager__item"><span class="pager__link pager__link--current">{{ pagination.currentPage }}</span></li>
          <template v-if="pagination.currentPage + 1 <= pagination.totalPages">
            <li class="pager__item"><b-link class="pager__link" :to="{ name: 'exam-category', params: { id: id, slug: slug }, query: { page: pagination.currentPage + 1 } }">{{ pagination.currentPage + 1 }}</b-link></li>
          </template>
          <template v-if="pagination.currentPage + 2 <= pagination.totalPages">
            <li class="pager__item"><b-link class="pager__link" :to="{ name: 'exam-category', params: { id: id, slug: slug }, query: { page: pagination.currentPage + 2 } }">{{ pagination.currentPage + 2 }}</b-link></li>
          </template>
          <template v-if="pagination.currentPage + 3 < pagination.totalPages">
            <li class="pager__item"><span class="pager__link pager__link--disable">...</span></li>
          </template>
          <template v-if="pagination.currentPage + 3 <= pagination.totalPages">
            <li class="pager__item"><b-link class="pager__link" :to="{ name: 'exam-category', params: { id: id, slug: slug }, query: { page: pagination.totalPages } }">&raquo;</b-link></li>
          </template>
        </ul>
      </div>
    </template>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { STORE_KEY } from '../_store/constants'
import ExamBox from '@/components/widgets/ExamBox.vue';

export default {
  name: 'ExamCategory',
  data() {
    return {
      id: this.$route.params.id,
      slug: this.$route.params.slug,
      page: this.$route.query.page || 1
    }
  },
  components: {
    ExamBox
  },
  metaInfo() {
    return {
      title: this.examCategory ? this.examCategory.meta_title : "Luyện thi HSK Online, thi chứng chỉ HSK trực tuyến",
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.examCategory ? this.examCategory.meta_description : "Luyện thi HSK Online, thi chứng chỉ tiếng Trung HSK đầy đủ các dạng, chính xác nhất."
        },
        {
          vmid: "keywords",
          name: "keywords",
          content: this.examCategory ? this.examCategory.meta_keywords : "hsk 1, hsk 2, hsk 3, hsk 4, hsk 5, hsk 6"
        },
        { vmid: "robots", name: "robots", content: "index, follow" },
        // OPG
        {
          property: "og:title",
          content: this.examCategory ? this.examCategory.meta_title : "Luyện thi HSK Online, thi chứng chỉ HSK trực tuyến"
        },
        { property: "og:site_name", content: "TryHSK Online" },
        // The list of types is available here: http://ogp.me/#types
        { property: "og:type", content: "article" },
        { property: "article:author", content: "https://tryhsk.com/" },
        { property: "og:url", content: `${process.env.BASE_URL}` },
        { property: "og:description", content: this.examCategory ? this.examCategory.meta_description : "Luyện thi HSK Online, thi chứng chỉ tiếng Trung trực tuyến chính xác nhất." },
        { property: "og:image", content: "https://tryhsk.com/uploads/articles/2020/03/18/5e71d24681a3d3339571.jpg" }
      ],
      link: [{ rel: "canonical", href: `${process.env.BASE_URL}` }]
    };
  },
  computed: {
    ...mapGetters({
      examCategory: `${STORE_KEY}/examCategory`,
      isLoading: `${STORE_KEY}/isLoading`,
      pagination: `${STORE_KEY}/pagination`
    })
  },
  beforeMount() {
    this.getExamCategory({
      id: this.id,
      page: this.page
    });
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, ['getExamCategory'])
  }
};
</script>